import React from "react";
import { Link } from "react-router-dom";
import { analyticsClickEvent } from "../../action/firebaseAnalytics/firebaseAnalytics";
import { PropTypes } from 'prop-types';
import IndustryImage from "../dashboard/home/industryImage";

class ContractList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

 

  render() {
    return (
      <React.Fragment>
        {this.props.items !== "" &&
          this.props.items.map((response) => (
            <div
              className="col-lg-6 col-md-6 col-12 left-card--item"
              key={response.contractId}
            >
              <div className="card">
               <Link
                  className="wallet-contract-detail" to="/wallet-contract-detail"
                  state={{ contract_id: response.contractId }}
                  onClick={(e) => analyticsClickEvent('wallet_contract', '')}>
                <div className="card-body">
                  <div className="inner-card--item">
                    <div className="sec--image">
                        <IndustryImage
                          src={response.contractAccountCover}
                          industryName={response.contractAccountName}
                        />
                    </div>
                    <div className="card--content">
					  <h2>Agreement Reference: {response.contractName}</h2>
					  <h2>{" "}{"Amount Borrowed: £" + response.contractLoanAmount}
                      </h2>
					  <p>Retailer: {response.contractAccountName}</p>
                      <span>
                        Repayment Amount: <span className="rate-span">£{response.contractApsTransactionAmount}</span>
                      </span>
                      <span>
						Balance Outstanding: £{response.contractBalanceOutStanding}
					  </span>
                    </div>
                    {response.contractNextPayment && response.contractNextPayment.length > 0 && (
                        <div className="payment-date">
                            <div className="date-pay-detail">
                               <p>{response.contractNextPayment[1]}</p>
                               <h3>{response.contractNextPayment[0]}</h3>
                            </div>
                        <span>Next Payment Due</span>
                    </div>
                    )}
                  </div>
                </div>
                </Link>
                <div className="card-footer">
                  <Link
                      className="card-footer"
                      to="/wallet-contract-detail"
                      state={{ contract_id: response.contractId }}
                      onClick={(e) => analyticsClickEvent('wallet_contract', '')}
                      class="text-right">
                    Go To Contract
                  </Link>
                  {/* <p className="text-right">Go To Contract</p> */}
                </div>
              </div>
            </div>
          ))}
      </React.Fragment>
    );
  }
}

ContractList.propTypes = {
  items: PropTypes.any
}

export default ContractList;
